import { getLocalStorage, setLocalStorage, clearAnyaDraft } from "utils/localStorageUtils"
import _ from 'lodash'

export const USER_ACTIVITY = "user_activity";
export const LAST_VISITED_DASHBOARD = "lastVisitedDashboard";
export const INSIGHT_ENV = 'insightEnv';
export const MANUAL_FINDING_PRODUCT_ID = 'manualFindingProductId';
export const MANUAL_FINDING_SUB_PRODUCT_ID = 'manualFindingSubProductId';
export const MANUAL_FINDING_ENV_ID = 'manualFindingEnvId';
export const LAST_SELECTED_GROUP_BY_OPTION = 'lastSelectedGroupByOptions';
export const ALL_BU_HIDE_EMPTY = 'ALL_BU_HIDE_EMPTY';
export const LAST_SELECTED_WIDGET_TYPE = 'lastSelectedWidgetType';
export const ANYA_SESSION_AGENT = 'anyaSessionAgent';

export const getTemporarySessionStorage = (key) => {
    return _.isUndefined(key) ? getLocalStorage(USER_ACTIVITY) : getLocalStorage(USER_ACTIVITY)[key]
}

export const setTemporarySessionStorage = (key, keyData) => {
    let data = getTemporarySessionStorage()
    data = {
        ...data,
        [key]: keyData
    }
    setLocalStorage(USER_ACTIVITY, data)
}

export const clearTemporarySessionStorage = () => {
    localStorage.removeItem(USER_ACTIVITY);
    clearAnyaDraft();
}

export const clearLastVisitedDashboard = () => {
    const storedData = getTemporarySessionStorage();
    delete storedData[LAST_VISITED_DASHBOARD];
    setLocalStorage(USER_ACTIVITY, storedData)
}

export function getAllBUHideEmpty(){
    return getTemporarySessionStorage(ALL_BU_HIDE_EMPTY);
}

export function setAllBUHideEmpty(value){
    return setTemporarySessionStorage(ALL_BU_HIDE_EMPTY, value);
}

export function getLastSelectedWidgetType(){
    return getTemporarySessionStorage(LAST_SELECTED_WIDGET_TYPE) || {};
}

export function setLastSelectedWidgetType(dashboardId, widgetType){
    const stored = getLastSelectedWidgetType();
    stored[dashboardId] = widgetType;
    return setTemporarySessionStorage(LAST_SELECTED_WIDGET_TYPE, stored);
}

// The clearLastSelectedWidgetType() intentionally clears the entire map. This is correct because only one dashboard is
// edited at a time — when switching to a different dashboard (one with no stored entry), the previous dashboard's widget
//  type preference is no longer needed. The conditional guard (Object.keys(stored).length && !stored[id]) ensures the
// map is preserved when navigating back to the same dashboard after a save (since stored[id] will exist). The map is
// session-scoped and cleared on logout, so there's no need to maintain entries across multiple dashboards
// simultaneously.
export function clearLastSelectedWidgetType(){
    const storedData = getTemporarySessionStorage();
    delete storedData[LAST_SELECTED_WIDGET_TYPE];
    setLocalStorage(USER_ACTIVITY, storedData);
}

